import React from 'react';

const Uganda1_mature_entry_math = () => {
  return (
    <div>
      
    </div>
  );
}

export default Uganda1_mature_entry_math;
